import type { AuthConnectParams, PasskeyParams } from '../actions/connect';
import { RoutePath } from '../pages';
import { hasPCDownloadUrl, openMobileUrl } from '../utils';
import { useConnector } from './useConnectors';
import useIsMobile from './useIsMobile';
import { useRouter } from './useRouter';
import type { WalletProps } from './useWalletsProps';

export const useConnectWithWallet = () => {
  const { navigate } = useRouter();
  const isMobile = useIsMobile();
  const connector = useConnector('walletConnect');

  const connectWallet = (
    walletProps: WalletProps,
    params?: { passkeyParams?: PasskeyParams; authParams?: AuthConnectParams }
  ) => {
    console.log(`connect wallet, id: ${walletProps.connector.id}, isInstalled: ${walletProps.isInstalled}`);
    if (walletProps.isInstalled) {
      navigate(RoutePath.Connecting, {
        wallet: walletProps,
        passkeyParams: params?.passkeyParams,
        authParams: params?.authParams,
      });
    } else if (walletProps.connector.id === 'walletConnect') {
      if (isMobile) {
        // loading, show w3m and close modal
        navigate(RoutePath.Connecting, { wallet: walletProps });
      } else {
        // walletconnect, show qrcode.
        navigate(RoutePath.Walletconnect, { wallet: walletProps });
      }
    } else if (walletProps.connector.chainType === 'evm' && walletProps.getWalletConnectDeeplink && connector) {
      if (isMobile) {
        // 跳转loading， 获取到uri后跳转
        navigate(RoutePath.Connecting, { wallet: walletProps });
      } else {
        // show qrcode.
        navigate(RoutePath.Walletconnect, { wallet: walletProps });
      }
    } else {
      // solana/evm wallets, unsupport walletconnect.
      if (walletProps.getDAppBrowserDeeplink && isMobile) {
        // deeplink -> dapp browser
        const url = walletProps.getDAppBrowserDeeplink(window.location.href);
        openMobileUrl(url);
      } else if (!isMobile && (hasPCDownloadUrl(walletProps) || walletProps.id === 'braveWallet')) {
        // download
        navigate(RoutePath.DownloadApp, { wallet: walletProps });
      } else {
        // unavailable, need to download wallet if has url.
        navigate(RoutePath.Connecting, { wallet: walletProps });
      }
    }
  };

  return connectWallet;
};
